/* eslint-disable react-hooks/immutability */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * This is the starting point of your application.
 * oneAudi OS and Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useContext, useEffect } from 'react';
import type { Logger } from '@feature-hub/core';
import type {
  TrackingService,
  ContentServiceV1,
  VueFormatterServiceInterfaceV1,
  LocaleServiceV1,
} from './feature-service-types';
import { useInViewEffect } from '@oneaudi/feature-app-utils';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import MinimalisticTypographicTeaser from './components/MinimalisticTypographicTeaser';
import { ContentContext } from './context';
import { getCtasForTracking } from '../helper/tracking';
import { getThemeName } from '../alpha-helper';

interface FeatureAppProps {
  trackingService?: TrackingService;
  content?: any;
  contentService?: ContentServiceV1 | undefined;
  loggerService?: Logger;
  vueFormatterService?: VueFormatterServiceInterfaceV1;
  localeService?: LocaleServiceV1;
}

const FeatureApp: React.FC<FeatureAppProps> = ({ ...inherited }: FeatureAppProps) => {
  const { localeService, trackingService: trackingServiceInherited } = inherited;
  const { content } = useContext(ContentContext);

  let trackingService = {} as TrackingService;

  if (typeof window !== 'undefined') {
    trackingService = trackingServiceInherited!;
  }

  useEffect(() => {
    trackingService.featureAppName = 'minimalistic-typographic-teaser';
    const readyEvent = {
      event: {
        attributes: {
          componentName: 'minimalistic-typographic-teaser',
          elementName: '',
          label: '',
          clickID: '',
          pos: '',
          targetURL: '',
          value: '',
        },
        eventInfo: {
          eventAction: 'feature_app_ready',
          eventName: 'minimalistic typographic teaser - feature app ready',
        },
      },
    };
    trackingService.track(readyEvent);
  }, []);

  useInViewEffect(() => {
    const readyEvent = {
      event: {
        attributes: {
          componentName: 'minimalistic-typographic-teaser',
          elementName: '',
          label: '',
          clickID: '',
          pos: '',
          targetURL: '',
          value: '',
          relatedElements: getCtasForTracking(content?.sectionHeaderCTAs),
        },
        eventInfo: {
          eventAction: 'impression',
          eventName: 'minimalistic typographic teaser - impression',
        },
      },
    };
    trackingService.track(readyEvent);
  });

  return (
    <ThemeProvider
      theme={{ name: getThemeName(content.themeContent.theme === 'darkTheme' ? 'dark' : 'light') }}
    >
      <MinimalisticTypographicTeaser
        content={content}
        localeService={localeService}
        trackingService={trackingService}
      />
    </ThemeProvider>
  );
};

export default FeatureApp;
